import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "megamenu" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "menu-items" }
const _hoisted_4 = { class: "item-content" }
const _hoisted_5 = ["aria-expanded", "aria-haspopup", "data-heap", "onClick"]
const _hoisted_6 = { class: "item-content" }
const _hoisted_7 = { class: "subcategory-parent-header" }
const _hoisted_8 = { class: "subcategory-content" }
const _hoisted_9 = { class: "user-controls" }
const _hoisted_10 = ["data-heap"]
const _hoisted_11 = { id: "dropdown-header-label" }
const _hoisted_12 = { class: "menu-content" }
const _hoisted_13 = { class: "menu-items" }
const _hoisted_14 = ["onMouseenter"]
const _hoisted_15 = { class: "item-content" }
const _hoisted_16 = ["aria-expanded", "aria-haspopup", "data-heap"]
const _hoisted_17 = { class: "item-content" }
const _hoisted_18 = {
  key: 0,
  class: "menu-subcategories"
}

import {getSliceComponentProps, PrismicRichText, SliceZone} from '@prismicio/vue';
    import {inject, onBeforeUnmount, onMounted, Ref, ref, computed} from 'vue';
    import {SharedSlice} from '@prismicio/types';
    import {components} from '@/unlogged/slices';
    import OptimizedImage from '@/unlogged/components/OptimizedImage.vue';
    import {MegamenuSlice, MegamenuSubcategorySlice} from '@/unlogged/prismicio';
    import {MEDIA_BREAKPOINTS, PRISMIC_HEADER_DOCUMENT, USER_LOCALE} from '@/unlogged/keys';
    import {ServerSideNavigationPrismicLink, usePrismicFieldHelpers, linkResolver, Dropdown, Collapsible} from '@malt/vue-prismic';
    import CountrySelection from '@/unlogged/components/CountrySelection.vue';
    import {useUserData} from '@/unlogged/composables/useUserData';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: getSliceComponentProps<MegamenuSlice>(),
  setup(__props) {

const props = __props;

    

    const locale = inject(USER_LOCALE);
    const userDataState = useUserData();
    const userData = computed(() => userDataState.value?.data);
    const breakpoints = inject(MEDIA_BREAKPOINTS);

    const currentItem: Ref<number | null> = ref(null);
    const currentSubcategoriesSlices = ref<MegamenuSubcategorySlice[]>([]);
    const isSubcategoryModalOpen = ref(false);

    const header = inject(PRISMIC_HEADER_DOCUMENT);
    const megamenuSubcategoriesSlices = header?.data?.slices?.filter((slice: SharedSlice) => slice.slice_type === 'megamenu_subcategory');
    const headerUserSlice = header?.data?.slices?.find((slice: SharedSlice) => slice.slice_type === 'header_user_slice');
    const countrySlice = header?.data?.slices?.find((slice: SharedSlice) => slice.slice_type === 'country_slice');

    const {isLink} = usePrismicFieldHelpers();
    function setCurrentItem(index: number | null) {
        currentItem.value = index;
        if (index !== null) {
            isSubcategoryModalOpen.value = true;
            currentSubcategoriesSlices.value = [
                props.slice.items[index].leftSubcategoryUid,
                props.slice.items[index].middleSubcategoryUid,
                props.slice.items[index].rightSubcategoryUid,
            ]
                .map((uid: string | null) =>
                    uid ? megamenuSubcategoriesSlices?.find((slice: MegamenuSubcategorySlice) => slice.primary.uid === uid) : undefined,
                )
                .filter((slice): slice is MegamenuSubcategorySlice => slice !== undefined);
        } else {
            currentSubcategoriesSlices.value = [];
            isSubcategoryModalOpen.value = false;
        }
    }
    function closeMegamenu() {
        setCurrentItem(null);
        isSubcategoryModalOpen.value = false;
    }
    onMounted(() => {
        window.addEventListener('Navigation', closeMegamenu);
    });
    onBeforeUnmount(() => {
        window.removeEventListener('Navigation', closeMegamenu);
    });

return (_ctx: any,_cache: any) => {
  const _component_joy_icon = _resolveComponent("joy-icon")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_unref(breakpoints)?.isTablet)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(Collapsible), {
            id: _ctx.slice.id ?? '',
            class: "collapsible"
          }, {
            header: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(_ctx.slice.primary.dropdownText), 1)
            ]),
            content: _withCtx(() => [
              _createVNode(_unref(PrismicRichText), {
                field: _ctx.slice.primary.title,
                class: "title"
              }, null, 8, ["field"]),
              _createElementVNode("ul", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slice.items, (item, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: `menu-item${index}`,
                    class: "menu-item-wrapper"
                  }, [
                    (_unref(isLink)('_', item.link))
                      ? (_openBlock(), _createBlock(_unref(ServerSideNavigationPrismicLink), {
                          key: 0,
                          field: item.link,
                          class: _normalizeClass({'menu-item': true, 'active': index === currentItem.value}),
                          "data-heap": item.itemHeapId,
                          "link-resolver": _unref(linkResolver)
                        }, {
                          default: _withCtx(() => [
                            _createVNode(OptimizedImage, {
                              "prismic-image": item.icon,
                              class: "icon",
                              height: "24",
                              width: "24",
                              sizes: "small:24px"
                            }, null, 8, ["prismic-image"]),
                            _createElementVNode("div", _hoisted_4, [
                              _createVNode(_unref(PrismicRichText), {
                                field: item.title,
                                class: "item-title"
                              }, null, 8, ["field"]),
                              _createVNode(_unref(PrismicRichText), {
                                field: item.subtitle,
                                class: "item-subtitle"
                              }, null, 8, ["field"])
                            ])
                          ]),
                          _: 2
                        }, 1032, ["field", "class", "data-heap", "link-resolver"]))
                      : (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          "aria-expanded": _unref(isLink)('_', item.link) ? undefined : index === currentItem.value,
                          "aria-haspopup": _unref(isLink)('_', item.link) ? undefined : 'menu',
                          class: _normalizeClass({'menu-item': true, 'active': index === currentItem.value}),
                          "data-heap": item.itemHeapId,
                          onClick: 
                                    () => {
                                        setCurrentItem(index);
                                    }
                                
                        }, [
                          _createVNode(OptimizedImage, {
                            "prismic-image": item.icon,
                            class: "icon",
                            height: "24",
                            width: "24",
                            sizes: "small:24px"
                          }, null, 8, ["prismic-image"]),
                          _createElementVNode("div", _hoisted_6, [
                            _createVNode(_unref(PrismicRichText), {
                              field: item.title,
                              class: "item-title"
                            }, null, 8, ["field"]),
                            _createVNode(_unref(PrismicRichText), {
                              field: item.subtitle,
                              class: "item-subtitle"
                            }, null, 8, ["field"])
                          ])
                        ], 10, _hoisted_5))
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }, 8, ["id"]),
          _createElementVNode("div", {
            class: _normalizeClass({'subcategory-dialog': true, 'open': currentItem.value !== null})
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = () => setCurrentItem(null))
              }, [
                _createVNode(_component_joy_icon, {
                  name: "arrow-left",
                  class: "arrow"
                })
              ]),
              (currentItem.value !== null)
                ? (_openBlock(), _createBlock(_unref(PrismicRichText), {
                    key: 0,
                    field: _ctx.slice.items[currentItem.value].title,
                    class: "subcategory-parent-title"
                  }, null, 8, ["field"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_unref(SliceZone), {
                slices: currentSubcategoriesSlices.value,
                components: _unref(components)
              }, null, 8, ["slices", "components"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              (_unref(headerUserSlice))
                ? (_openBlock(), _createBlock(_unref(SliceZone), {
                    key: 0,
                    slices: [_unref(headerUserSlice)],
                    components: _unref(components)
                  }, null, 8, ["slices", "components"]))
                : _createCommentVNode("", true),
              _createVNode(CountrySelection, {
                "country-slice": _unref(countrySlice),
                locale: _unref(locale),
                "user-info": _unref(userData)?.info
              }, null, 8, ["country-slice", "locale", "user-info"])
            ])
          ], 2)
        ]))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "dropdown",
          "data-heap": _ctx.slice.primary.buttonHeapId
        }, [
          _createVNode(_unref(Dropdown), {
            id: _ctx.slice.id ?? '',
            "menu-class": "menu"
          }, {
            header: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.slice.primary.dropdownText) + " ", 1),
              _createVNode(_component_joy_icon, {
                name: "chevron-down",
                class: "chevron"
              })
            ]),
            content: _withCtx(() => [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_unref(PrismicRichText), {
                  field: _ctx.slice.primary.title,
                  class: "title"
                }, null, 8, ["field"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("ul", _hoisted_13, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slice.items, (item, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: `menu-item${index}`,
                      class: "menu-item-wrapper",
                      onMouseenter: 
                                    () => {
                                        setCurrentItem(index);
                                    }
                                
                    }, [
                      (_unref(isLink)('_', item.link))
                        ? (_openBlock(), _createBlock(_unref(ServerSideNavigationPrismicLink), {
                            key: 0,
                            field: item.link,
                            class: _normalizeClass({'menu-item': true, 'active': index === currentItem.value}),
                            "data-heap": item.itemHeapId,
                            "link-resolver": _unref(linkResolver)
                          }, {
                            default: _withCtx(() => [
                              _createVNode(OptimizedImage, {
                                "prismic-image": item.icon,
                                class: "icon",
                                height: "24",
                                width: "24",
                                sizes: "small:24px"
                              }, null, 8, ["prismic-image"]),
                              _createElementVNode("div", _hoisted_15, [
                                _createVNode(_unref(PrismicRichText), {
                                  field: item.title,
                                  class: "item-title"
                                }, null, 8, ["field"]),
                                _createVNode(_unref(PrismicRichText), {
                                  field: item.subtitle,
                                  class: "item-subtitle"
                                }, null, 8, ["field"])
                              ])
                            ]),
                            _: 2
                          }, 1032, ["field", "class", "data-heap", "link-resolver"]))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            "aria-expanded": _unref(isLink)('_', item.link) ? undefined : index === currentItem.value,
                            "aria-haspopup": _unref(isLink)('_', item.link) ? undefined : 'menu',
                            class: _normalizeClass({'menu-item': true, 'active': index === currentItem.value}),
                            "data-heap": item.itemHeapId
                          }, [
                            _createVNode(OptimizedImage, {
                              "prismic-image": item.icon,
                              class: "icon",
                              height: "24",
                              width: "24",
                              sizes: "small:24px"
                            }, null, 8, ["prismic-image"]),
                            _createElementVNode("div", _hoisted_17, [
                              _createVNode(_unref(PrismicRichText), {
                                field: item.title,
                                class: "item-title"
                              }, null, 8, ["field"]),
                              _createVNode(_unref(PrismicRichText), {
                                field: item.subtitle,
                                class: "item-subtitle"
                              }, null, 8, ["field"])
                            ])
                          ], 10, _hoisted_16))
                    ], 40, _hoisted_14))
                  }), 128))
                ]),
                ((currentSubcategoriesSlices.value || []).length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createVNode(_unref(SliceZone), {
                        slices: currentSubcategoriesSlices.value,
                        components: _unref(components)
                      }, null, 8, ["slices", "components"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["id"])
        ], 8, _hoisted_10))
  ]))
}
}

})